const MUTATION_TYPE = {
  // olympiads
  setCurrentOlympiad: 'setCurrentOlympiad'
}

const ACTION_TYPE = {
  // olympiads
  fetchCurrentOlympiad: 'fetchCurrentOlympiad',
  registerInOlympiad: 'registerInOlympiad'
}

const GETTER_TYPE = {
  // olympiads
  getCurrentOlympiad: 'getCurrentOlympiad'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
